import y from "../../../../public/projects/paranjape/projects/y.jpg";
import s from "../../../../public/projects/paranjape/logo/s.png";
import evergreen from "../../../../public/projects/paranjape/projects/ev.jpg"

// ridges41
import overviewImageridges41 from "../../../../public/projects/paranjape/ridges41/overview/1.webp";
import bannerDesktopImageridges41 from "../../../../public/projects/paranjape/ridges41/banner/1.webp";
import bannerMobileImageridges41 from "../../../../public/projects/paranjape/ridges41/banner/2.webp";
import Locationridges41 from "../../../../public/projects/paranjape/ridges41/location/1.webp";
import Hightlightsridges41 from "../../../../public/projects/paranjape/ridges41/highlights/1.webp";
import floorplan1ridges41 from "../../../../public/projects/paranjape/ridges41/floorplan/1.webp";
import floorplan2ridges41 from "../../../../public/projects/paranjape/ridges41/floorplan/2.webp";
import floorplan3ridges41 from "../../../../public/projects/paranjape/ridges41/floorplan/3.webp";
import floorplan4ridges41 from "../../../../public/projects/paranjape/ridges41/floorplan/4.webp";
import floorplan5ridges41 from "../../../../public/projects/paranjape/ridges41/floorplan/5.webp";
import locationiconridges41 from "../../../../public/projects/paranjape/ridges41/overview/l.png";
import caliconridges41 from "../../../../public/projects/paranjape/ridges41/overview/c.png";
import newlaunchiconridges41 from "../../../../public/projects/paranjape/ridges41/overview/n.png";
import gallery1ridges41 from "../../../../public/projects/paranjape/ridges41/gallery/1.webp";
import gallery2ridges41 from "../../../../public/projects/paranjape/ridges41/gallery/2.webp";
import gallery3ridges41 from "../../../../public/projects/paranjape/ridges41/gallery/3.webp";
import gallery4ridges41 from "../../../../public/projects/paranjape/ridges41/gallery/4.webp";
import gallery5ridges41 from "../../../../public/projects/paranjape/ridges41/gallery/5.webp";

// tridenttowers
import overviewImagetridenttowers from "../../../../public/projects/paranjape/tridenttowers/overview/1.webp";
import bannerDesktopImagetridenttowers from "../../../../public/projects/paranjape/tridenttowers/banner/1.webp";
import bannerMobileImagetridenttowers from "../../../../public/projects/paranjape/tridenttowers/banner/2.webp";
import Locationtridenttowers from "../../../../public/projects/paranjape/tridenttowers/location/1.webp";
import Hightlightstridenttowers from "../../../../public/projects/paranjape/tridenttowers/highlights/1.webp";
import floorplan1tridenttowers from "../../../../public/projects/paranjape/tridenttowers/floorplan/1.webp";
import floorplan2tridenttowers from "../../../../public/projects/paranjape/tridenttowers/floorplan/2.webp";
import floorplan3tridenttowers from "../../../../public/projects/paranjape/tridenttowers/floorplan/3.webp";
import floorplan4tridenttowers from "../../../../public/projects/paranjape/tridenttowers/floorplan/4.webp";
import floorplan5tridenttowers from "../../../../public/projects/paranjape/tridenttowers/floorplan/5.webp";
import locationicontridenttowers from "../../../../public/projects/paranjape/tridenttowers/overview/l.png";
import calicontridenttowers from "../../../../public/projects/paranjape/tridenttowers/overview/c.png";
import newlaunchicontridenttowers from "../../../../public/projects/paranjape/tridenttowers/overview/n.png";
import gallery1tridenttowers from "../../../../public/projects/paranjape/tridenttowers/gallery/1.webp";
import gallery2tridenttowers from "../../../../public/projects/paranjape/tridenttowers/gallery/2.webp";
import gallery3tridenttowers from "../../../../public/projects/paranjape/tridenttowers/gallery/3.webp";
import gallery4tridenttowers from "../../../../public/projects/paranjape/tridenttowers/gallery/4.webp";
import gallery5tridenttowers from "../../../../public/projects/paranjape/tridenttowers/gallery/5.webp";

// projectthree
import overviewImageprojectthree from "../../../../public/projects/paranjape/projectthree/overview/1.webp";
import bannerDesktopImageprojectthree from "../../../../public/projects/paranjape/projectthree/banner/1.webp";
import bannerMobileImageprojectthree from "../../../../public/projects/paranjape/projectthree/banner/2.webp";
import Locationprojectthree from "../../../../public/projects/paranjape/projectthree/location/1.webp";
import Hightlightsprojectthree from "../../../../public/projects/paranjape/projectthree/highlights/1.webp";
import floorplan1projectthree from "../../../../public/projects/paranjape/projectthree/floorplan/1.webp";
import floorplan2projectthree from "../../../../public/projects/paranjape/projectthree/floorplan/2.webp";
import floorplan3projectthree from "../../../../public/projects/paranjape/projectthree/floorplan/3.webp";
import floorplan4projectthree from "../../../../public/projects/paranjape/projectthree/floorplan/4.webp";
import floorplan5projectthree from "../../../../public/projects/paranjape/projectthree/floorplan/5.webp";
import locationiconprojectthree from "../../../../public/projects/paranjape/projectthree/overview/l.png";
import caliconprojectthree from "../../../../public/projects/paranjape/projectthree/overview/c.png";
import newlaunchiconprojectthree from "../../../../public/projects/paranjape/projectthree/overview/n.png";
import gallery1projectthree from "../../../../public/projects/paranjape/projectthree/gallery/1.webp";
import gallery2projectthree from "../../../../public/projects/paranjape/projectthree/gallery/2.webp";
import gallery3projectthree from "../../../../public/projects/paranjape/projectthree/gallery/3.webp";
import gallery4projectthree from "../../../../public/projects/paranjape/projectthree/gallery/4.webp";
import gallery5projectthree from "../../../../public/projects/paranjape/projectthree/gallery/5.webp";

// projectfour
import overviewImageprojectfour from "../../../../public/projects/paranjape/projectfour/overview/1.webp";
import bannerDesktopImageprojectfour from "../../../../public/projects/paranjape/projectfour/banner/1.webp";
import bannerMobileImageprojectfour from "../../../../public/projects/paranjape/projectfour/banner/2.webp";
import Locationprojectfour from "../../../../public/projects/paranjape/projectfour/location/1.webp";
import Hightlightsprojectfour from "../../../../public/projects/paranjape/projectfour/highlights/1.webp";
import floorplan1projectfour from "../../../../public/projects/paranjape/projectfour/floorplan/1.webp";
import floorplan2projectfour from "../../../../public/projects/paranjape/projectfour/floorplan/2.webp";
import floorplan3projectfour from "../../../../public/projects/paranjape/projectfour/floorplan/3.webp";
import floorplan4projectfour from "../../../../public/projects/paranjape/projectfour/floorplan/4.webp";
import floorplan5projectfour from "../../../../public/projects/paranjape/projectfour/floorplan/5.webp";
import locationiconprojectfour from "../../../../public/projects/paranjape/projectfour/overview/l.png";
import caliconprojectfour from "../../../../public/projects/paranjape/projectfour/overview/c.png";
import newlaunchiconprojectfour from "../../../../public/projects/paranjape/projectfour/overview/n.png";
import gallery1projectfour from "../../../../public/projects/paranjape/projectfour/gallery/1.webp";
import gallery2projectfour from "../../../../public/projects/paranjape/projectfour/gallery/2.webp";
import gallery3projectfour from "../../../../public/projects/paranjape/projectfour/gallery/3.webp";
import gallery4projectfour from "../../../../public/projects/paranjape/projectfour/gallery/4.webp";
import gallery5projectfour from "../../../../public/projects/paranjape/projectfour/gallery/5.webp";

// projectfive
import overviewImageprojectfive from "../../../../public/projects/paranjape/projectfive/overview/1.webp";
import bannerDesktopImageprojectfive from "../../../../public/projects/paranjape/projectfive/banner/1.webp";
import bannerMobileImageprojectfive from "../../../../public/projects/paranjape/projectfive/banner/2.webp";
import Locationprojectfive from "../../../../public/projects/paranjape/projectfive/location/1.webp";
import Hightlightsprojectfive from "../../../../public/projects/paranjape/projectfive/highlights/1.webp";
import floorplan1projectfive from "../../../../public/projects/paranjape/projectfive/floorplan/1.webp";
import floorplan2projectfive from "../../../../public/projects/paranjape/projectfive/floorplan/2.webp";
import floorplan3projectfive from "../../../../public/projects/paranjape/projectfive/floorplan/3.webp";
import floorplan4projectfive from "../../../../public/projects/paranjape/projectfive/floorplan/4.webp";
import floorplan5projectfive from "../../../../public/projects/paranjape/projectfive/floorplan/5.webp";
import locationiconprojectfive from "../../../../public/projects/paranjape/projectfive/overview/l.png";
import caliconprojectfive from "../../../../public/projects/paranjape/projectfive/overview/c.png";
import newlaunchiconprojectfive from "../../../../public/projects/paranjape/projectfive/overview/n.png";
import gallery1projectfive from "../../../../public/projects/paranjape/projectfive/gallery/1.webp";
import gallery2projectfive from "../../../../public/projects/paranjape/projectfive/gallery/2.webp";
import gallery3projectfive from "../../../../public/projects/paranjape/projectfive/gallery/3.webp";
import gallery4projectfive from "../../../../public/projects/paranjape/projectfive/gallery/4.webp";
import gallery5projectfive from "../../../../public/projects/paranjape/projectfive/gallery/5.webp";

// projectsix
import overviewImageprojectsix from "../../../../public/projects/paranjape/projectsix/overview/1.webp";
import bannerDesktopImageprojectsix from "../../../../public/projects/paranjape/projectsix/banner/1.webp";
import bannerMobileImageprojectsix from "../../../../public/projects/paranjape/projectsix/banner/2.webp";
import Locationprojectsix from "../../../../public/projects/paranjape/projectsix/location/1.webp";
import Hightlightsprojectsix from "../../../../public/projects/paranjape/projectsix/highlights/1.webp";
import floorplan1projectsix from "../../../../public/projects/paranjape/projectsix/floorplan/1.webp";
import floorplan2projectsix from "../../../../public/projects/paranjape/projectsix/floorplan/2.webp";
import floorplan3projectsix from "../../../../public/projects/paranjape/projectsix/floorplan/3.webp";
import floorplan4projectsix from "../../../../public/projects/paranjape/projectsix/floorplan/4.webp";
import floorplan5projectsix from "../../../../public/projects/paranjape/projectsix/floorplan/5.webp";
import locationiconprojectsix from "../../../../public/projects/paranjape/projectsix/overview/l.png";
import caliconprojectsix from "../../../../public/projects/paranjape/projectsix/overview/c.png";
import newlaunchiconprojectsix from "../../../../public/projects/paranjape/projectsix/overview/n.png";
import gallery1projectsix from "../../../../public/projects/paranjape/projectsix/gallery/1.webp";
import gallery2projectsix from "../../../../public/projects/paranjape/projectsix/gallery/2.webp";
import gallery3projectsix from "../../../../public/projects/paranjape/projectsix/gallery/3.webp";
import gallery4projectsix from "../../../../public/projects/paranjape/projectsix/gallery/4.webp";
import gallery5projectsix from "../../../../public/projects/paranjape/projectsix/gallery/5.webp";

// projectseven
import overviewImageprojectseven from "../../../../public/projects/paranjape/projectseven/overview/1.webp";
import bannerDesktopImageprojectseven from "../../../../public/projects/paranjape/projectseven/banner/1.webp";
import bannerMobileImageprojectseven from "../../../../public/projects/paranjape/projectseven/banner/2.webp";
import Locationprojectseven from "../../../../public/projects/paranjape/projectseven/location/1.webp";
import Hightlightsprojectseven from "../../../../public/projects/paranjape/projectseven/highlights/1.webp";
import floorplan1projectseven from "../../../../public/projects/paranjape/projectseven/floorplan/1.webp";
import floorplan2projectseven from "../../../../public/projects/paranjape/projectseven/floorplan/2.webp";
import floorplan3projectseven from "../../../../public/projects/paranjape/projectseven/floorplan/3.webp";
import floorplan4projectseven from "../../../../public/projects/paranjape/projectseven/floorplan/4.webp";
import floorplan5projectseven from "../../../../public/projects/paranjape/projectseven/floorplan/5.webp";
import locationiconprojectseven from "../../../../public/projects/paranjape/projectseven/overview/l.png";
import caliconprojectseven from "../../../../public/projects/paranjape/projectseven/overview/c.png";
import newlaunchiconprojectseven from "../../../../public/projects/paranjape/projectseven/overview/n.png";
import gallery1projectseven from "../../../../public/projects/paranjape/projectseven/gallery/1.webp";
import gallery2projectseven from "../../../../public/projects/paranjape/projectseven/gallery/2.webp";
import gallery3projectseven from "../../../../public/projects/paranjape/projectseven/gallery/3.webp";
import gallery4projectseven from "../../../../public/projects/paranjape/projectseven/gallery/4.webp";
import gallery5projectseven from "../../../../public/projects/paranjape/projectseven/gallery/5.webp";

// projecteight
import overviewImageprojecteight from "../../../../public/projects/paranjape/projecteight/overview/1.webp";
import bannerDesktopImageprojecteight from "../../../../public/projects/paranjape/projecteight/banner/1.webp";
import bannerMobileImageprojecteight from "../../../../public/projects/paranjape/projecteight/banner/2.webp";
import Locationprojecteight from "../../../../public/projects/paranjape/projecteight/location/1.webp";
import Hightlightsprojecteight from "../../../../public/projects/paranjape/projecteight/highlights/1.webp";
import floorplan1projecteight from "../../../../public/projects/paranjape/projecteight/floorplan/1.webp";
import floorplan2projecteight from "../../../../public/projects/paranjape/projecteight/floorplan/2.webp";
import floorplan3projecteight from "../../../../public/projects/paranjape/projecteight/floorplan/3.webp";
import floorplan4projecteight from "../../../../public/projects/paranjape/projecteight/floorplan/4.webp";
import floorplan5projecteight from "../../../../public/projects/paranjape/projecteight/floorplan/5.webp";
import locationiconprojecteight from "../../../../public/projects/paranjape/projecteight/overview/l.png";
import caliconprojecteight from "../../../../public/projects/paranjape/projecteight/overview/c.png";
import newlaunchiconprojecteight from "../../../../public/projects/paranjape/projecteight/overview/n.png";
import gallery1projecteight from "../../../../public/projects/paranjape/projecteight/gallery/1.webp";
import gallery2projecteight from "../../../../public/projects/paranjape/projecteight/gallery/2.webp";
import gallery3projecteight from "../../../../public/projects/paranjape/projecteight/gallery/3.webp";
import gallery4projecteight from "../../../../public/projects/paranjape/projecteight/gallery/4.webp";
import gallery5projecteight from "../../../../public/projects/paranjape/projecteight/gallery/5.webp";

// projectnine
import overviewImageprojectnine from "../../../../public/projects/paranjape/projectnine/overview/1.webp";
import bannerDesktopImageprojectnine from "../../../../public/projects/paranjape/projectnine/banner/1.webp";
import bannerMobileImageprojectnine from "../../../../public/projects/paranjape/projectnine/banner/2.webp";
import Locationprojectnine from "../../../../public/projects/paranjape/projectnine/location/1.webp";
import Hightlightsprojectnine from "../../../../public/projects/paranjape/projectnine/highlights/1.webp";
import floorplan1projectnine from "../../../../public/projects/paranjape/projectnine/floorplan/1.webp";
import floorplan2projectnine from "../../../../public/projects/paranjape/projectnine/floorplan/2.webp";
import floorplan3projectnine from "../../../../public/projects/paranjape/projectnine/floorplan/3.webp";
import floorplan4projectnine from "../../../../public/projects/paranjape/projectnine/floorplan/4.webp";
import floorplan5projectnine from "../../../../public/projects/paranjape/projectnine/floorplan/5.webp";
import locationiconprojectnine from "../../../../public/projects/paranjape/projectnine/overview/l.png";
import caliconprojectnine from "../../../../public/projects/paranjape/projectnine/overview/c.png";
import newlaunchiconprojectnine from "../../../../public/projects/paranjape/projectnine/overview/n.png";
import gallery1projectnine from "../../../../public/projects/paranjape/projectnine/gallery/1.webp";
import gallery2projectnine from "../../../../public/projects/paranjape/projectnine/gallery/2.webp";
import gallery3projectnine from "../../../../public/projects/paranjape/projectnine/gallery/3.webp";
import gallery4projectnine from "../../../../public/projects/paranjape/projectnine/gallery/4.webp";
import gallery5projectnine from "../../../../public/projects/paranjape/projectnine/gallery/5.webp";

// projectten
import overviewImageprojectten from "../../../../public/projects/paranjape/projectten/overview/1.webp";
import bannerDesktopImageprojectten from "../../../../public/projects/paranjape/projectten/banner/1.webp";
import bannerMobileImageprojectten from "../../../../public/projects/paranjape/projectten/banner/2.webp";
import Locationprojectten from "../../../../public/projects/paranjape/projectten/location/1.webp";
import Hightlightsprojectten from "../../../../public/projects/paranjape/projectten/highlights/1.webp";
import floorplan1projectten from "../../../../public/projects/paranjape/projectten/floorplan/1.webp";
import floorplan2projectten from "../../../../public/projects/paranjape/projectten/floorplan/2.webp";
import floorplan3projectten from "../../../../public/projects/paranjape/projectten/floorplan/3.webp";
import floorplan4projectten from "../../../../public/projects/paranjape/projectten/floorplan/4.webp";
import floorplan5projectten from "../../../../public/projects/paranjape/projectten/floorplan/5.webp";
import locationiconprojectten from "../../../../public/projects/paranjape/projectten/overview/l.png";
import caliconprojectten from "../../../../public/projects/paranjape/projectten/overview/c.png";
import newlaunchiconprojectten from "../../../../public/projects/paranjape/projectten/overview/n.png";
import gallery1projectten from "../../../../public/projects/paranjape/projectten/gallery/1.webp";
import gallery2projectten from "../../../../public/projects/paranjape/projectten/gallery/2.webp";
import gallery3projectten from "../../../../public/projects/paranjape/projectten/gallery/3.webp";
import gallery4projectten from "../../../../public/projects/paranjape/projectten/gallery/4.webp";
import gallery5projectten from "../../../../public/projects/paranjape/projectten/gallery/5.webp";



export const developerparanjape = {
  properties: [
    {
      name: "paranjape The Trillion",
      image: bannerMobileImageridges41,
      price: " 6.14 Crore Onwards",
      state: " Gurugram",
      developer: "paranjape",
      location: "Sector 48, Gurugram",
      projectlocation: "Gurugram",
      bed: "3,4 BHK Apartments",
      size: "3000-3600 sq.ft.",
      url: `/paranjape-trillion`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "paranjape The Trillion",
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
  ],
};
export const Headers = {
  logo: s,
  data: {
    experience: "2006",
  },
  about: `paranjape, a 100% FDI funded real-estate developer, backed by paranjape Holdings Pte. Ltd., Singapore, the real estate investing division of the AT Holdings group of companies. AT Capital, headquartered in Singapore, was established with the aim of capitalizing on global opportunities within both established and emerging sectors.`,
};


export const projectsparanjape = {

  ridges41: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageridges41,
      bannerMobileImage: bannerMobileImageridges41,
      textOverlay: "",
      data: {
        title: "The Ridges 41",
        subtitle: "Hinjewadi, Pune",
        starting_price: "₹ 1.81 Crore Onwards",
        payment_plan: "20:40:40",
        rerano: "P52100055581",
        status: "Under Construction"
      }
    },

    overview: {
      heading: "The Ridges 41 in Hinjewadi, Pune",
      description: [
        "The Ridges 41 in Hinjewadi, Pune is a premium residential offering by Paranjape Schemes, located within the well-known Blue Ridge Township. Designed for modern homebuyers who seek a balance between luxury, comfort, and urban convenience, this high-rise project stands tall with 41 floors, offering panoramic views of the city skyline and lush surroundings. The project offers beautifully planned 2, 3, and 4 BHK apartments, each crafted to ensure maximum space utilization, natural light, and a seamless living experience.",
        "What sets The Ridges 41 apart is its unique integration of lifestyle and functionality. Residents here get to enjoy a range of thoughtfully designed amenities that cater to all age groups. Whether it's relaxing in the landscaped gardens, working out in the state-of-the-art gym, enjoying quality time at the clubhouse, or letting kids play in dedicated zones, every need is taken care of. There's also a swimming pool, multipurpose hall, home theatre, work-from-home pods, and even a virtual reality gaming zone. These features make everyday life more enjoyable and fulfilling without needing to step outside the township.",
      ],
      keywordLinks: {
      },
      image: overviewImageridges41,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconridges41,
          title: "₹ 1.81 Crore Onwards",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconridges41,
          title: "Under Construction",
          subtitle: "Status",
        },
        {
          iconClass: newlaunchiconridges41,
          title: "2028",
          subtitle: "Possession",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK",
          area: "792.77 - 799.66 sq.ft.",
          price: "₹ 90.8 - 92 L",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK",
          area: "1272.41 sq.ft.",
          price: "₹ 1.51 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "5 BHK",
          area: "1592.32 - 1612.66 sq.ft.",
          price: "₹ 1.9 - 1.92 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK",
        area: "792.77 - 799.66 sq.ft.",
        price: "₹ 90.8 - 92 L",
        image: floorplan1ridges41,
      },
      {
        type: "4 BHK",
        area: "1272.41 sq.ft.",
        price: "₹ 1.51 Cr",
        image: floorplan2ridges41,
      },
      {
        type: "5 BHK",
        area: "1592.32 - 1612.66 sq.ft.",
        price: "₹ 1.9 - 1.92 Cr",
        image: floorplan3ridges41,
      }
    ],

    highlights: {
      images: Hightlightsridges41,
      tagline: "Highlights",
      features: [
        "7000+ sqft of unparalleled amenities",
        "Podium-level landscaping to integrate greenery with vertical living",
        "6 levels of parking",
        "Close to well-known work areas",
        "Self-sufficient towers with indoor and outdoor recreational spaces"
      ],
    },

    location: {
      image: Locationridges41,
      data: [
        {
          airport: {
            distance_time: "24.1 km",
            name: "Pune International Airport"
          },
          school: {
            distance_time: "1.8 km",
            name: "I2IT Engineering College"
          },
          railwayormetro: {
            distance_time: "12.1 km",
            name: "PCMC Metro Station"
          },
          hospital: {
            distance_time: "2.1 km",
            name: "Sanjeevani Multispeciality Hospital"
          },
          mall: {
            distance_time: "2 km",
            name: "Xion Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1ridges41 },
        { image: gallery2ridges41 },
        { image: gallery3ridges41 },
        { image: gallery4ridges41 },
        { image: gallery5ridges41 },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in The Ridges 41, Hinjewadi, kindly share more details.",
    },

    faq: [
      {
        question: "Where is The Ridges 41 located?",
        answer: `The project is located in Hinjewadi Phase 1, Pune.`,
      },
      {
        question: "What types of apartments are available at The Ridges 41?",
        answer: `The project offers 2 BHK, 3 BHK, and 4 BHK luxury apartments.`,
      },
      {
        question: "What is the starting price of apartments in The Ridges 41?",
        answer: `The starting price for apartments in The Ridges 41 is approximately ₹1.81 Crore.`,
      },
      {
        question: "Is The Ridges 41 RERA registered?",
        answer: `Yes, The Ridges 41 is RERA registered with the registration number P52100055581.`,
      },
      {
        question: "When is the possession date for The Ridges 41?",
        answer: `The possession for homes at The Ridges 41 is expected in the year 2028.`,
      },
      {
        question: "Who is the developer of The Ridges 41?",
        answer: `The Ridges 41 is developed by Paranjape Schemes.`,
      },
      {
        question: "What amenities are offered in The Ridges 41?",
        answer: `Key amenities include a swimming pool, clubhouse, gymnasium, children's play area, landscaped gardens, and more.`,
      },
      {
        question: "What makes The Ridges 41 unique?",
        answer: `It is a 41-storey high-rise offering premium homes with modern features and smart amenities.`,
      },
      {
        question: "Are there any schools or institutions nearby?",
        answer: `Yes, reputed institutions like I2IT Engineering College are located nearby.`,
      },
      {
        question: "Is The Ridges 41 a good investment option?",
        answer: `Absolutely. With its prime location, luxurious features, and trusted developer, The Ridges 41 offers strong potential for end-use and long-term investment.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  tridenttowers: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImagetridenttowers,
      bannerMobileImage: bannerMobileImagetridenttowers,
      textOverlay: "",
      data: {
        title: "paranjape The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "paranjape The Trillion",
      description: [
        "paranjape The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by paranjape Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at paranjape Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at paranjape Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of paranjape The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "paranjape": "/developers/paranjape",
      },
      image: overviewImagetridenttowers,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationicontridenttowers,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: calicontridenttowers,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchicontridenttowers,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1tridenttowers,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2tridenttowers,
      }
    ],

    highlights: {
      images: Hightlightstridenttowers,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationtridenttowers,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1tridenttowers },
        { image: gallery2tridenttowers },
        { image: gallery3tridenttowers },
        { image: gallery4tridenttowers },
        { image: gallery5tridenttowers },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in paranjape The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is paranjape The Trillion located?",
        answer: `paranjape The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at paranjape The Trillion?",
        answer: `paranjape The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in paranjape The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at paranjape The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, paranjape The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of paranjape The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at paranjape The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of paranjape The Trillion?",
        answer: `paranjape The Trillion is developed by paranjape Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is paranjape The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, paranjape The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from paranjape The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectthree: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectthree,
      bannerMobileImage: bannerMobileImageprojectthree,
      textOverlay: "",
      data: {
        title: "paranjape The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "paranjape The Trillion",
      description: [
        "paranjape The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by paranjape Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at paranjape Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at paranjape Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of paranjape The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "paranjape": "/developers/paranjape",
      },
      image: overviewImageprojectthree,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectthree,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectthree,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectthree,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectthree,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectthree,
      }
    ],

    highlights: {
      images: Hightlightsprojectthree,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectthree,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectthree },
        { image: gallery2projectthree },
        { image: gallery3projectthree },
        { image: gallery4projectthree },
        { image: gallery5projectthree },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in paranjape The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is paranjape The Trillion located?",
        answer: `paranjape The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at paranjape The Trillion?",
        answer: `paranjape The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in paranjape The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at paranjape The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, paranjape The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of paranjape The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at paranjape The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of paranjape The Trillion?",
        answer: `paranjape The Trillion is developed by paranjape Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is paranjape The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, paranjape The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from paranjape The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectfour: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectfour,
      bannerMobileImage: bannerMobileImageprojectfour,
      textOverlay: "",
      data: {
        title: "paranjape The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "paranjape The Trillion",
      description: [
        "paranjape The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by paranjape Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at paranjape Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at paranjape Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of paranjape The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "paranjape": "/developers/paranjape",
      },
      image: overviewImageprojectfour,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectfour,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectfour,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectfour,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectfour,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectfour,
      }
    ],

    highlights: {
      images: Hightlightsprojectfour,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectfour,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectfour },
        { image: gallery2projectfour },
        { image: gallery3projectfour },
        { image: gallery4projectfour },
        { image: gallery5projectfour },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in paranjape The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is paranjape The Trillion located?",
        answer: `paranjape The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at paranjape The Trillion?",
        answer: `paranjape The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in paranjape The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at paranjape The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, paranjape The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of paranjape The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at paranjape The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of paranjape The Trillion?",
        answer: `paranjape The Trillion is developed by paranjape Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is paranjape The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, paranjape The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from paranjape The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectfive: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectfive,
      bannerMobileImage: bannerMobileImageprojectfive,
      textOverlay: "",
      data: {
        title: "paranjape The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "paranjape The Trillion",
      description: [
        "paranjape The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by paranjape Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at paranjape Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at paranjape Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of paranjape The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "paranjape": "/developers/paranjape",
      },
      image: overviewImageprojectfive,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectfive,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectfive,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectfive,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectfive,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectfive,
      }
    ],

    highlights: {
      images: Hightlightsprojectfive,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectfive,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectfive },
        { image: gallery2projectfive },
        { image: gallery3projectfive },
        { image: gallery4projectfive },
        { image: gallery5projectfive },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in paranjape The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is paranjape The Trillion located?",
        answer: `paranjape The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at paranjape The Trillion?",
        answer: `paranjape The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in paranjape The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at paranjape The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, paranjape The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of paranjape The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at paranjape The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of paranjape The Trillion?",
        answer: `paranjape The Trillion is developed by paranjape Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is paranjape The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, paranjape The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from paranjape The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectsix: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectsix,
      bannerMobileImage: bannerMobileImageprojectsix,
      textOverlay: "",
      data: {
        title: "paranjape The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "paranjape The Trillion",
      description: [
        "paranjape The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by paranjape Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at paranjape Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at paranjape Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of paranjape The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "paranjape": "/developers/paranjape",
      },
      image: overviewImageprojectsix,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectsix,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectsix,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectsix,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectsix,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectsix,
      }
    ],

    highlights: {
      images: Hightlightsprojectsix,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectsix,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectsix },
        { image: gallery2projectsix },
        { image: gallery3projectsix },
        { image: gallery4projectsix },
        { image: gallery5projectsix },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in paranjape The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is paranjape The Trillion located?",
        answer: `paranjape The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at paranjape The Trillion?",
        answer: `paranjape The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in paranjape The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at paranjape The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, paranjape The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of paranjape The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at paranjape The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of paranjape The Trillion?",
        answer: `paranjape The Trillion is developed by paranjape Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is paranjape The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, paranjape The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from paranjape The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectseven: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectseven,
      bannerMobileImage: bannerMobileImageprojectseven,
      textOverlay: "",
      data: {
        title: "paranjape The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "paranjape The Trillion",
      description: [
        "paranjape The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by paranjape Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at paranjape Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at paranjape Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of paranjape The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "paranjape": "/developers/paranjape",
      },
      image: overviewImageprojectseven,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectseven,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectseven,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectseven,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectseven,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectseven,
      }
    ],

    highlights: {
      images: Hightlightsprojectseven,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectseven,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectseven },
        { image: gallery2projectseven },
        { image: gallery3projectseven },
        { image: gallery4projectseven },
        { image: gallery5projectseven },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in paranjape The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is paranjape The Trillion located?",
        answer: `paranjape The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at paranjape The Trillion?",
        answer: `paranjape The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in paranjape The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at paranjape The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, paranjape The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of paranjape The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at paranjape The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of paranjape The Trillion?",
        answer: `paranjape The Trillion is developed by paranjape Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is paranjape The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, paranjape The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from paranjape The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projecteight: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojecteight,
      bannerMobileImage: bannerMobileImageprojecteight,
      textOverlay: "",
      data: {
        title: "paranjape The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "paranjape The Trillion",
      description: [
        "paranjape The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by paranjape Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at paranjape Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at paranjape Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of paranjape The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "paranjape": "/developers/paranjape",
      },
      image: overviewImageprojecteight,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojecteight,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojecteight,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojecteight,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projecteight,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projecteight,
      }
    ],

    highlights: {
      images: Hightlightsprojecteight,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojecteight,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projecteight },
        { image: gallery2projecteight },
        { image: gallery3projecteight },
        { image: gallery4projecteight },
        { image: gallery5projecteight },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in paranjape The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is paranjape The Trillion located?",
        answer: `paranjape The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at paranjape The Trillion?",
        answer: `paranjape The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in paranjape The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at paranjape The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, paranjape The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of paranjape The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at paranjape The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of paranjape The Trillion?",
        answer: `paranjape The Trillion is developed by paranjape Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is paranjape The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, paranjape The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from paranjape The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectnine: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectnine,
      bannerMobileImage: bannerMobileImageprojectnine,
      textOverlay: "",
      data: {
        title: "paranjape The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "paranjape The Trillion",
      description: [
        "paranjape The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by paranjape Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at paranjape Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at paranjape Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of paranjape The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "paranjape": "/developers/paranjape",
      },
      image: overviewImageprojectnine,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectnine,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectnine,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectnine,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectnine,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectnine,
      }
    ],

    highlights: {
      images: Hightlightsprojectnine,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectnine,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectnine },
        { image: gallery2projectnine },
        { image: gallery3projectnine },
        { image: gallery4projectnine },
        { image: gallery5projectnine },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in paranjape The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is paranjape The Trillion located?",
        answer: `paranjape The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at paranjape The Trillion?",
        answer: `paranjape The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in paranjape The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at paranjape The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, paranjape The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of paranjape The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at paranjape The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of paranjape The Trillion?",
        answer: `paranjape The Trillion is developed by paranjape Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is paranjape The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, paranjape The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from paranjape The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectten: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectten,
      bannerMobileImage: bannerMobileImageprojectten,
      textOverlay: "",
      data: {
        title: "paranjape The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "paranjape The Trillion",
      description: [
        "paranjape The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by paranjape Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at paranjape Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at paranjape Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of paranjape The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "paranjape": "/developers/paranjape",
      },
      image: overviewImageprojectten,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectten,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectten,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectten,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectten,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectten,
      }
    ],

    highlights: {
      images: Hightlightsprojectten,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectten,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectten },
        { image: gallery2projectten },
        { image: gallery3projectten },
        { image: gallery4projectten },
        { image: gallery5projectten },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in paranjape The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is paranjape The Trillion located?",
        answer: `paranjape The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at paranjape The Trillion?",
        answer: `paranjape The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in paranjape The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at paranjape The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, paranjape The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of paranjape The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at paranjape The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of paranjape The Trillion?",
        answer: `paranjape The Trillion is developed by paranjape Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is paranjape The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, paranjape The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from paranjape The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
};
